
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Typography,
  Grid,
  Box,
  Dialog,
  Autocomplete,
  TextField,
  Button,
} from "@mui/material";
import Notify from "../../../Notify";
import Alerta from "../../../Alerta";
import { logEventos } from "../../../../services/services";
import { postData, putData } from "../../../../services/library";

function ModalEleccionTanque(props) {
  const { datos, open, handleClose, actualizar, tanquesAsociados } = props;
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [tanque, setTanque] = useState([]);
  const [tanqueSeleccionado, setTanqueSeleccionado] = useState([]);
  const [tanquesOrdenados, setTanquesOrdenados] = useState([]);

  const calcularDistancia = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radio de la Tierra en km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // distancia en km
  };


  const getTanques = async () => {
    try {
      const [resDisponibles] = await Promise.all([
        fetch(UrlApi + "/tanques/disponibles"),
      ]);

      const disponibles = await resDisponibles.json();

      let capacidadesRequeridas = [];

      // ---------------------------------------------------------------------
      // 👉 SI ES REEMPLAZO (id_motivo === 20), CAPACIDADES VIENEN DE TANQUES ASOCIADOS
      // ---------------------------------------------------------------------
      if (datos.id_motivo === 41) {

        capacidadesRequeridas = tanquesAsociados
          ?.map((t) => (t.capacidad))
          .filter((cap) => cap > 0);

      } else {
        // ---------------------------------------------------------------------
        // 👉 CASO NORMAL (INSTALACIÓN): CAPACIDADES VIENEN DE datos.canttk_X
        // ---------------------------------------------------------------------
        const capacidadesMap = {
          canttk_05: 0.5,
          canttk_1: 1,
          canttk_2: 2,
          canttk_4: 4,
          canttk_7: 7,
        };
        capacidadesRequeridas = Object.entries(capacidadesMap)
          .filter(([key]) => datos[key] && datos[key] > 0)
          .map(([, capacidad]) => capacidad);
      }

      // ---------------------------------------------------------------------
      // 👉 SI NO HAY CAPACIDADES → devolver lista vacía
      // ---------------------------------------------------------------------
      if (capacidadesRequeridas.length === 0) {
        console.warn("No se encontró ninguna capacidad válida");
        setTanque([]);
        return;
      }
      // ---------------------------------------------------------------------
      // 👉 FILTRAR TANQUES DISPONIBLES POR LAS CAPACIDADES
      // ---------------------------------------------------------------------
      const filtrados = disponibles.filter((t) =>
        capacidadesRequeridas.includes(Number(t.capacidad))
      );

    console.log("tanques filtrados", filtrados);

    // 3️⃣ Setear estado
    setTanque(filtrados);

  } catch (error) {
    console.error("Error al obtener tanques filtrados:", error);
    setTanque([]);
  }
};

  useEffect(() => {
    getTanques()
  }, [])

  useEffect(() => {
    if (tanque?.length && datos?.latitud && datos?.longitud) {
      const lat = parseFloat(datos.latitud);
      const lon = parseFloat(datos.longitud);

      const ordenados = tanque
        .map(t => {
          const latSuc = parseFloat(t.latitud);
          const lonSuc = parseFloat(t.longitud);

          // si alguna coordenada es inválida, no calculamos distancia
          const distancia =
            isNaN(lat) || isNaN(lon) || isNaN(latSuc) || isNaN(lonSuc)
              ? null
              : calcularDistancia(lat, lon, latSuc, lonSuc);

          return { ...t, distancia };
        })
        // filtramos los que tienen distancia nula para evitar NaN en el sort
        .filter(t => t.distancia !== null)
        .sort((a, b) => a.distancia - b.distancia);

      setTanquesOrdenados(ordenados);
    } else {
      setTanquesOrdenados(tanque);
    }
  }, [tanque, datos.latitud, datos.longitud]);

  const guardarReclamo = async (e) => {
    await guardarRelacion(e);
    await cambiarEstadoTanque(e);
    actualizar();
    handleClose();

  };

  //FUNCION PARA GUARDAR EL RECLAMO CON CADA UNO DE LOS TANQUES 
  const guardarRelacion = async (e) => {
    logEventos(
      `Guardar eleccion del tanque a reclamo ${datos.id_reclamo}`,
      "Instalaciones/Desconexionesl",
      "Se guardo la eleccion del tanque",
      localStorage.getItem("user")
    );

    //recorro  el array de tanques seleccionados para hacer el post por cada registro.
    for (let tanque of tanqueSeleccionado) {
      postData(e,
        '/reclamos_tanques',
        {
          id_tanque: tanque.id,
          uuid_reclamo_tanque: datos.uuid,
          usuario: localStorage.getItem("user"),
          //esto es para dar despues el alta de la relacion del tanque con la direccion de entrega. 
          //para saber CUAL ES EL QUE TENGO QUE DAR DE ALTA Y CUAL ES EL QUE TENGO QUE DAR DE BAJA
          instalacion: 1
        },
        setNotificacion
      )
    }
  };

  //funcion para cambiar el estado del tanque seleccionado
  const cambiarEstadoTanque = async (e) => {
    for (let tanque of tanqueSeleccionado) {
      logEventos(
        `Cambiar de estado el tanque ${tanque.nro_serie}`,
        "Instalaciones/Desconexiones",
        "Se cambio de estado el tanque seleccionado para la instalación",
        localStorage.getItem("user")
      );
      putData(e,
        `/tanques/${tanque.id}`,
        {
          id_estado: 8,
          a24: localStorage.getItem('user')
        },
        setNotificacion
      )
    }
  };


  const validarSeleccionTanques = () => {
    let capacidadesRequeridas = {};

    // Caso especial → motivo 41 usa tanques asociados
    if (datos.id_motivo === 41) {
      tanquesAsociados.forEach((t) => {
        const cap = t.capacidad;
        capacidadesRequeridas[cap] = (capacidadesRequeridas[cap] || 0) + 1;
      });
    }
    // Otros motivos → usar valores del formulario
    else {
      capacidadesRequeridas = {
        0.5: datos.canttk_05 ?? 0,
        1: datos.canttk_1 ?? 0,
        2: datos.canttk_2 ?? 0,
        4: datos.canttk_4 ?? 0,
        7: datos.canttk_7 ?? 0,
      };
    }

    // Contar lo que seleccionó el usuario
    const cuentaSeleccionada = {};
    tanqueSeleccionado.forEach((tanque) => {
      const cap = tanque.capacidad;
      cuentaSeleccionada[cap] = (cuentaSeleccionada[cap] || 0) + 1;
    });

    // Validación
    for (const cap in capacidadesRequeridas) {
      const requerido = capacidadesRequeridas[cap];
      const seleccionado = cuentaSeleccionada[cap] || 0;

      if (seleccionado !== requerido) {
        return {
          valido: false,
          mensaje: `Debe seleccionar ${requerido} tanque(s) de capacidad ${cap}m3`,
        };
      }
    }

    return { valido: true };
  };
  useEffect(() => {
    validarSeleccionTanques()
  }, [])

  const handleGuardar = (e) => {
    e.preventDefault();
    const validacion = validarSeleccionTanques();
    if (!validacion.valido) {
      alert(`${validacion.mensaje}`)
      return;
    }

    guardarReclamo(e); // Solo guarda si pasa la validación
  };

  const getLimitesCapacidad = () => {
    if (datos.id_motivo === 41) {
      const caps = {};
      tanquesAsociados?.forEach(t => {
        caps[t.capacidad] = (caps[t.capacidad] || 0) + 1;
      });
      return caps;
    }

    return {
      0.5: datos.canttk_05 ?? 0,
      1: datos.canttk_1 ?? 0,
      2: datos.canttk_2 ?? 0,
      4: datos.canttk_4 ?? 0,
      7: datos.canttk_7 ?? 0,
    };
  };

  const limites = getLimitesCapacidad();

  const cuentaSeleccionada = {};
  tanqueSeleccionado.forEach(t => {
    cuentaSeleccionada[t.capacidad] =
      (cuentaSeleccionada[t.capacidad] || 0) + 1;
  });

  const seleccionCompleta = Object.keys(limites).every((cap) => {
    const requerido = limites[cap] ?? 0;
    const seleccionado = cuentaSeleccionada[cap] ?? 0;
    return seleccionado >= requerido;
  });

  // FILTRADO FINAL → solo mostrar los tanques que todavía se pueden elegir
  const tanquesFiltrados = tanquesOrdenados.filter((t) => {
    const limite = limites[t.capacidad];

    if (limite === undefined || limite === null) return true;
    if (limite === 0) return false;

    const seleccionados = cuentaSeleccionada[t.capacidad] || 0;
    return seleccionados < limite;
  });

  const noHayTanques = tanquesFiltrados.length === 0;

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 4,
          },
        }}
      >
        {/* Título */}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{
            backgroundColor: "#1F618D",
            py: 2,
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{ color: "#fff", textAlign: "center" }}
          >
            Elección de Tanque :
          </Typography>
        </Grid>

        {/* Autocomplete */}
        <Box sx={{ p: 3 }}>
          {!tanque ? (
            "NO HAY TANQUES "
          ) : (
            <Autocomplete
              multiple
              id="id_tanque"
              size="medium"
              options={tanquesFiltrados}
              fullWidth
              value={tanqueSeleccionado}
              onChange={(event, newValue) => setTanqueSeleccionado(newValue)}
              noOptionsText={
                seleccionCompleta
                  ? "Ya seleccionaste todos los tanques necesarios"
                  : noHayTanques
                    ? "No hay tanques disponibles para seleccionar"
                    : "No coincide ningún tanque con la búsqueda"
              }
              getOptionLabel={(option) => {
                if (!option) return "";
                const base = `N° ${option.nro_serie} - cap. ${option.capacidad} - Suc: ${option.sucursal}`;
                return option.distancia
                  ? `${base} (${option.distancia.toFixed(1)} km)`
                  : base;
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Elegir tanque..."
                  placeholder="Buscar..."
                />
              )}
            />



          )}

          <Grid
            container
            justifyContent="space-between"
            alignItems="flex-end"
            mt={2}
          >
            <Button variant="contained" color="error" onClick={handleClose}>
              VOLVER
            </Button>
            <Button
              variant="contained"
              onClick={handleGuardar} // en vez de guardarReclamo directamente
              color="success"
              disabled={!tanqueSeleccionado || tanqueSeleccionado.length === 0}
            >
              GUARDAR
            </Button>
          </Grid>
        </Box>

        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={handleClose}
            severity={notificacion.severity}
          />
        ) : null}
      </Dialog>
    </div>
  );
}

export default ModalEleccionTanque;
//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date :25/04/2025
// Version : 1
// Description : Para elegir los tanques en instalaciones
//
//------Changes ----------------------------------------------------------//
// Change Date : 13/11/2025
// Change by : Candela Grosso
// Change description: Modificaciones varias. toddavia no se de q

//========================================================================/